<template>
    <div class="delete">

        <!-- Steps -->
        <div class="signup__container">
            <div class="step__container">
                
                <div class="step__button" ref="button">
                    <a href="#" @click.prevent="buttonClicked" :class="{
                        'button button--full': true 
                        }" >

                        <span class="button__title">Test button</span>
                        <!-- <span class="button__subtitle">This is PERMANENT</span> -->
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import ErrorModal from '@/components/1-common/ErrorModal';
    import Preloader from '@/components/1-common/Preloader';
    import InputField from "@/components/1-common/InputField";
    import { logEntry } from '../../tools/logEntryFile';

    export default {
        name: 'Test',
        components: {
            ErrorModal,
            Preloader,
            InputField
        },
        data() {
            return {
                duh: false
            }
        },
        computed: {

            userGetter: function () {

                return ''
            }
        },
        methods: {

            buttonClicked() {

                console.log('button clicked!');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Test.vue?3858cda9